module.exports = new __parcel__URL__("multiple-flags.fdb5d926.svg").toString();